// extracted by mini-css-extract-plugin
module.exports = {"overlay":"RenderSearch_overlay__3rDap","container":"RenderSearch_container__21DKs"};